/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Grid from '../../components/Grid/Grid';
import List from '../../components/List/List';
import Skeleton from '../../components/Skeleton/Skeleton';
import orderStyle from './Order.scss';
import s from './OrderSkeleton.scss';

const OrderSkeleton = () => {
  return (
    <>
      <div className={cx(orderStyle.top, s.skeleton)}>
        <Skeleton width="340px" height="30px" className={orderStyle.heading} />
        <Skeleton width="100%" height="20px" className={s.middleLine} />
        <Skeleton width="400px" height="20px" />
      </div>
      <Grid container justify="center" alignItems="flex-end" spacing={16}>
        <Grid item>
          <List container direction="column" spacing={4} className={s.skeleton}>
            <List item component="li" className={orderStyle.date}>
              <Skeleton width="220px" height="20px" />
            </List>
            <List item component="li">
              <Skeleton width="250px" height="20px" />
            </List>
          </List>
        </Grid>
      </Grid>
      <List
        container
        spacing={24}
        direction="column"
        className={cx(orderStyle.bottom, s.skeleton)}
      >
        <List item component="li">
          <Skeleton width="400px" height="20px" />
        </List>
        <List item component="li" className={orderStyle.buttonContainer}>
          <Skeleton width="170px" height="34px" className={s.button} />
        </List>
      </List>
    </>
  );
};

export default withStyles(orderStyle, s)(OrderSkeleton);
